export const YODHA_COLORS = {
  primary: "#00a19d",
  secondary: "#fff8e5",
  yellow: "#f6b242",
  grey: "#ececec",
  darkGrey: "#415a6c",
  greyAlt: "#a4a6a5",
};
